import { render, staticRenderFns } from "./UnionView.vue?vue&type=template&id=48464542&scoped=true&"
import script from "./UnionView.vue?vue&type=script&lang=js&"
export * from "./UnionView.vue?vue&type=script&lang=js&"
import style0 from "./UnionView.vue?vue&type=style&index=0&id=48464542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48464542",
  null
  
)

export default component.exports